export default {
	//日期格式化，e为空时，获取当前日期
	dateFormat: (e) => {
		let now = null
		if (typeof e === 'undefined') {
			now = new Date();
		} else {
			now = new Date(e);
		}
		let yy = now.getFullYear();
		var mm = (now.getMonth() + 1) < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
		var dd = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
		return yy + "-" + mm + "-" + dd;
	},
	//时间格式化，e为空时，获取当前时间
	timeFormat: (e) => {
		let now = null
		if (typeof e === 'undefined') {
			now = new Date();
		} else {
			now = new Date(e);
		}
		let yy = now.getFullYear();
		var mm = (now.getMonth() + 1) < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
		var dd = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
		let hh = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();;
		let mf = now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
		let ss = now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
		return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
	},
	parseTime(time, pattern) {
		if (arguments.length === 0 || !time) {
			return null
		}
		const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
		let date
		if (typeof time === 'object') {
			date = time
		} else {
			if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
				time = parseInt(time)
			} else if (typeof time === 'string') {
				time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
			}
			if ((typeof time === 'number') && (time.toString().length === 10)) {
				time = time * 1000
			}
			date = new Date(time)
		}
		const formatObj = {
			y: date.getFullYear(),
			m: date.getMonth() + 1,
			d: date.getDate(),
			h: date.getHours(),
			i: date.getMinutes(),
			s: date.getSeconds(),
			a: date.getDay()
		}
		const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
			let value = formatObj[key]
			// Note: getDay() returns 0 on Sunday
			if (key === 'a') {
				return ['日', '一', '二', '三', '四', '五', '六'][value]
			}
			if (result.length > 0 && value < 10) {
				value = '0' + value
			}
			return value || 0
		})
		return time_str
	}


}